<div *ngIf="isLoading$ | async; else loaded">
  <div class="loading-section">
    <div class="margin-auto">
      <app-main-loader-lottie> </app-main-loader-lottie>
    </div>
  </div>
</div>

<ng-template #loaded>
  <div class="abtest-layout">
    <div class="container">
      <div class="header">
        <div class="header__title">
          <pdq-button size="large" icon="side_left_arrow" (onClick)="backToList()" variant="light"></pdq-button>
          <pdq-heading element="h3">{{ (activeCheckout$ | async)?.name }}</pdq-heading>
        </div>
        <pdq-button variant="secondary" (click)="createABTest()" [disabled]="isLoading$ | async"
          >Create A/B test</pdq-button
        >
      </div>

      <div class="subtitle">Performance & A/B testing</div>

      <div class="card">
        <div class="card__header">
          <div class="card__box">
            <pdq-heading element="h6">Lifetime performance</pdq-heading>
          </div>
        </div>
        <div class="data-table">
          <pdq-data-table [columns]="columns" [rows]="(variantTestGroups$ | async)?.original">
            <ng-template #rowsTemplate let-row="row">
              <ng-container *ngFor="let column of columns">
                <td>
                  <div class="row">
                    <div class="cell">
                      <ng-container *ngIf="column.type === ColumnTypes.TITLE">
                        <span style="color: var(--on-surface-light)">{{ row[column.prop] }}</span>
                      </ng-container>

                      <ng-container *ngIf="column.type === ColumnTypes.PERCENT">
                        <!--                        {{ row[column.prop] | percent: '1.2-2' }}-->
                      </ng-container>

                      <ng-container *ngIf="column.type === ColumnTypes.CURRENCY">
                        <!--                        {{ row[column.prop] | currency: currency }}-->
                      </ng-container>

                      <ng-container *ngIf="!column.type">
                        <!--                        {{ row[column.prop] }}-->
                      </ng-container>
                    </div>
                  </div>
                </td>
              </ng-container>
            </ng-template>
          </pdq-data-table>
        </div>
      </div>

      <ng-container *ngFor="let testGroup of (variantTestGroups$ | async)?.testGroups; let i = index">
        <div class="card">
          <div class="card__header">
            <div class="card__box">
              <pdq-heading element="h6">#Test {{ (variantTestGroups$ | async)?.testGroups?.length - i }}</pdq-heading>
              <span class="subtitle">
                <pdq-tag
                  style="color: var(--on-surface-default)"
                  mode="rect"
                  [variant]="testGroup.data['finishedAt'] ? 'default' : 'quaternary'"
                  >{{ testGroup.data['finishedAt'] ? 'Completed' : 'Active' }}</pdq-tag
                >
                <pdq-tag
                  *ngIf="
                    (settings$ | async)?.runTestVariantsTogether &&
                    testGroup.data['finishedAt'] &&
                    testGroup.data['appearanceLimit'] &&
                    testGroup.data['appearanceLimit'] <= testGroup.data['testVariantAppearance']
                  "
                  style="color: var(--on-surface-default)"
                  mode="rect"
                  variant="default"
                  >Paused by</pdq-tag
                >
              </span>
            </div>
            <div class="card__box">
              <span class="subtitle">
                {{ (testGroup?.data)['createdAt'] | date: 'MMM dd' }} -
                {{
                  (testGroup?.data)['finishedAt'] ? ((testGroup?.data)['finishedAt'] | date: 'MMM dd') : 'ongoing'
                }}</span
              >
              <pdq-button
                pdqPopover
                variant="ghost"
                icon="dots_menu"
                [popoverTemplate]="popoverTemplate"
                [forcePosition]="'bottom'"
                [closeOnPopoverClick]
                [closeOnClickOutside]="true"></pdq-button>

              <ng-template #popoverTemplate>
                <pdq-popover-container [loading]="false" [actionList]="true">
                  <div class="action-list">
                    <ng-container *ngFor="let option of options">
                      <pdq-option
                        (onSelect)="onAction(option.value, testGroup)"
                        [disabled]="
                          option.value
                            | disableABTestMenuAction: testGroup?.data : (variantTestGroups$ | async)?.testGroups
                        ">
                        {{ option.label | titlecase }}
                      </pdq-option>
                    </ng-container>
                  </div></pdq-popover-container
                >
              </ng-template>
            </div>
          </div>
          <div class="data-table">
            <pdq-data-table class="table" [columns]="columns" [rows]="testGroup?.groups">
              <ng-template #rowsTemplate let-row="row">
                <ng-container *ngFor="let column of columns">
                  <td>
                    <div class="row">
                      <div class="cell">
                        <ng-container *ngIf="column.type === ColumnTypes.TITLE">
                          <div class="title">
                            <span style="color: var(--on-surface-light)">{{ row[column.prop] }}</span>
                            <pdq-tag *ngIf="row.type === testGroup.data['winnerType']" mode="rect" variant="quaternary"
                              >Winner</pdq-tag
                            >
                          </div>
                        </ng-container>

                        <ng-container *ngIf="column.type === ColumnTypes.PERCENT">
                          <!--                          {{ row[column.prop] | percent: '1.2-2' }}-->
                        </ng-container>

                        <ng-container *ngIf="column.type === ColumnTypes.CURRENCY">
                          <!--                          {{ row[column.prop] | currency: currency }}-->
                        </ng-container>

                        <ng-container *ngIf="!column.type">
                          <!--                          {{ row[column.prop] }}-->
                        </ng-container>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <td>
                  <div class="actions">
                    <pdq-button
                      variant="light"
                      (onClick)="setWinner(testGroup, row.type)"
                      [disabled]="!!testGroup.data?.winnerType"
                      >Set as winner</pdq-button
                    >
                  </div>
                </td>
              </ng-template>
            </pdq-data-table>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
